import { Group, Paper, Select, Switch } from '@common/ui'
import TrimmedTextInput from './TrimmedTextInput'
import { com } from '@eidu/web'
import SingleLine = com.eidu.sharedlib.form.definition.SingleLine
import InputType = com.eidu.sharedlib.form.definition.InputType
import { withKey } from '../../util/withKey'
import FormKeyField from './FormKeyField'

type SingleLineItemProps = {
  item: SingleLine
  onChange?: (newItem: SingleLine) => void
  onDelete?: () => void
}

const SingleLineItem: React.FC<SingleLineItemProps> = ({ item, onChange }) => (
  <Paper withBorder radius="sm" p="xs">
    <Group gap="md" wrap="nowrap" align="flex-start">
      <TrimmedTextInput
        style={{ flex: 1 }}
        value={item.prompt}
        onChange={(e) => onChange?.(withKey(item.copy(e.target.value, item.key, item.inputType, item.required), item))}
        placeholder="Enter prompt"
        label="Prompt"
        disabled={!onChange}
      />
      <FormKeyField
        value={item.key}
        onChange={(e) =>
          onChange?.(withKey(item.copy(item.prompt, e.target.value, item.inputType, item.required), item))
        }
        disabled={!onChange}
      />
      <Select
        label="Input Type"
        style={{ minWidth: 120 }}
        value={item.inputType.name}
        onChange={(value) =>
          value && onChange?.(withKey(item.copy(item.prompt, item.key, InputType.valueOf(value), item.required), item))
        }
        data={InputType.values().map((type) => type.name)}
        disabled={!onChange}
      />
      <Switch
        checked={item.required}
        onChange={(e) => onChange?.(withKey(item.copy(item.prompt, item.key, item.inputType, e.target.checked), item))}
        disabled={!onChange}
        label="Required"
      />
    </Group>
  </Paper>
)

export default SingleLineItem
